define('tinymce-plugins/wa5_headings/plugin',['tinymce/AddOnManager'], function(AddOnManager) {
	AddOnManager.PluginManager.add('wa5_headings', function(editor) {
		for (var headingIndex = 1; headingIndex <= 2; headingIndex++) {
			(function(headingIndex) {
				if (headingIndex == 1) {
					var tooltip = '\u00dcberschrift';
				} else {
					var tooltip = 'Unter\u00FCberschrift';
				}
				editor.addButton('wa5_h' + headingIndex, {
					image: editor.baseURI.directory + '/plugins/wa5_headings/icons/heading' + headingIndex + '.png',
					tooltip: tooltip,
					shortcut: 'Ctrl+' + headingIndex,
					onclick: function() {
						editor.execCommand('mceToggleFormat', false, 'h' + headingIndex);
					},
					stateSelector: 'h' + headingIndex
				});
			})(headingIndex);
		}
	});
});

